import React, { useContext, useMemo } from 'react';

import './CorporateActionsWidgetDetails.scss';
import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { getCorporateActionsColDefs } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanel } from 'utils/components/GridDetailsPanel/GridDetailsPanel';
import { getPanelColumnDefs } from 'widgets/corpActions/widget/details/sections';
import AppContext from 'app/AppContext';

export interface CorporateActionsWidgetDetailsProps {
    height: number;
    width: number;
    corporateAction: SymbolEvent;
}
export function CorporateActionsWidgetDetails(
    props: CorporateActionsWidgetDetailsProps
) {
    const { height, width, corporateAction } = props;
    const context = useContext(AppContext);

    const style = { height: `${height}px` };

    const panelColumnDefs = getPanelColumnDefs(corporateAction);
    const colDefs = useMemo(
        () => getCorporateActionsColDefs(context),
        [context]
    );

    return (
        <div className="CorporateActionsWidgetDetails" style={style}>
            <GridDetailsPanel
                colDefs={colDefs}
                panelColumnDefs={panelColumnDefs}
                entity={corporateAction}
                width={width}
            />
        </div>
    );
}
